import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

// import ExtraOption from "components/OptionsBox/ExtraOptions/index";
import { CustomTooltip } from "components";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#333",
    maxWidth: 100,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    maxWidth: 100,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    // border: 0,
  },
}));

export default function PerformanceReport({ showButtons = false, data }) {
  return (
    <div>
      <TableContainer component={Paper} className="!hayley-rounded-none">
        <Table aria-label="customized table">
          <TableHead>
            <TableRow>
              {data?.headers?.map((header, index) => (
                <StyledTableCell key={index}>{header}</StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.rows?.map((row, index) => (
              <StyledTableRow key={row.tool}>
                <StyledTableCell component="th" scope="row">
                  <CustomTooltip title={row.tool} placement="bottom">
                    {row.tool || 0}
                  </CustomTooltip>
                </StyledTableCell>
                <StyledTableCell>{row.t_id || 0}</StyledTableCell>
                <StyledTableCell>{row.time || 0}</StyledTableCell>
                <StyledTableCell>{row.all_tok || 0}</StyledTableCell>
                <StyledTableCell>{row["cost¢"] || 0}</StyledTableCell>
                <StyledTableCell>{row.i_tok || 0}</StyledTableCell>
                <StyledTableCell>{row["inp¢"] || 0}</StyledTableCell>
                <StyledTableCell>{row.o_tok || 0}</StyledTableCell>
                <StyledTableCell>{row["out¢"] || 0}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/* {showButtons ? <ExtraOption from="report" /> : null} */}
    </div>
  );
}
